// RIoT IO brand design tokens — navy + gold + white.

export const colors = {
  navy: {
    950: "#0D0F18",
    900: "#13162A",
    800: "#1A1D2E",
    700: "#252840",
    600: "#353958",
    500: "#4A4F72",
    400: "#6B7094",
    300: "#8B90B0",
    200: "#C0C4D8",
    100: "#E4E6EE",
    50: "#F4F5F8",
  },

  gold: {
    500: "#C4A32E",
    400: "#D4B84A",
    300: "#E0CC72",
    200: "#ECDF9E",
    100: "#F5ECC5",
    50: "#FBF7E8",
  },

  status: {
    online: "#22C55E",
    // Stale = device has missed its expected check-in window but
    // not by enough to count as offline. Derived server-side from
    // lastSeen + checkInMinutes. Amber slots between online (green)
    // and offline (slate) in the existing palette.
    stale: "#F59E0B",
    offline: "#94A3B8",
    inactive: "#CBD5E1",
    updating: "#3B82F6",
    error: "#EF4444",
  },

  chart: {
    gold: "#C4A32E",
    green: "#22C55E",
    blue: "#3B82F6",
    red: "#EF4444",
    navy: "#4A4F72",
    lightGold: "#E0CC72",
  },
} as const;
